import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  noop,
  sortBy,
} from 'lodash';
import QRCode from 'qrcode.react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import {
  Badge,
  HighlightText,
  Toggle,
} from 'components';
import { getPermissionWarning } from 'constants/options';
import EditItemButton from '../EditItemButton';
import ProductItemImage from '../ProductItemImage';
import { withStyles } from '@material-ui/core/styles';
import {
  compose,
  setDisplayName,
} from 'recompose';

const styles = theme => ({
  tableRowRoot: {
    height: '40px'
  }
});

class StoreTableRow extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
  };
  static propTypes = {
    data: PropTypes.shape({
      image: PropTypes.string,
    }).isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    id: PropTypes.number,
    isCatalog: PropTypes.bool,
    isFarm: PropTypes.bool,
    isMarketPlace: PropTypes.bool,
    isWarehouse: PropTypes.bool,
    imageRequesting: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    readOnlyForPermission: PropTypes.bool,
    searchText: PropTypes.string,

    onUploadImage: PropTypes.func.isRequired,
    onRemoveImage: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    innerRef: PropTypes.func,
    updateStateData: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    onImageClick: PropTypes.func,
    isAllowedToUpdate: PropTypes.bool,
    isRetailPage: PropTypes.bool,
    classes: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    id: null,
    innerRef: noop,
    isCatalog: false,
    isFarm: false,
    isMarketPlace: false,
    readOnly: false,
    readOnlyForPermission: false,
    searchText: '',
    onImageClick: noop,
    isAllowedToUpdate: true,
    isRetailPage: false,
  };

  state = {
    currentTime: new Date().getTime(),
    storeData: [],
  };

  componentWillMount() {
    const { data } = this.props;
    this.setState({ storeData: data });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ storeData: nextProps.data });
    }
  }

  getDetailedData = () => {
    const { isDistributor } = this.context;
    const {
      id,
      isCatalog,
      isFarm,
      isMarketPlace,
      imageRequesting,
      onUploadImage,
      onRemoveImage,
      formatMessage,
      readOnly,
      readOnlyForPermission,
      reloadStore,
      updateStateData,
      onImageClick,
      isAllowedToUpdate,
      isRetailPage,
      isWarehouse
    } = this.props;
    const { storeData } = this.state;
    const detailData = [];
    const image = storeData.image || null;
    let packRowCount = 0;
    const sortedStoreData = storeData;
    sortedStoreData.packrows = sortBy(sortedStoreData.packrows, 'count');
    sortedStoreData.packrows.forEach((packrow, index) => {
      packRowCount++;
      if (packRowCount > 1) {
        detailData.push({
          ...storeData,
          ...packrow,
          bulkTotalQty: 0,
          category: storeData.productData.category,
          hide: [
            'status',
            'category',
            'name',
            'subname',
            'sourcename',
            'updatedAt',
            'action',
            'qty',
            'description',
            'tags',
            'approved',
            'image'
          ],
          id: storeData.id,
          index,
          name: storeData.productData.name,
          subname: storeData.productData.subname,
        });
        return;
      }
      const toggler = (
        <span
          title={formatMessage(storeData.approved ? 'Item Available' : 'Item Unavailable')}
          style={{ height: '40px' }}
        >
          <Toggle
            color={isRetailPage ? 'blue' : ''}
            disabled={isAllowedToUpdate ? readOnlyForPermission : true}
            onToggle={(e, isInputChecked) =>
              this.toggle(isInputChecked)}
            toggled={storeData.approved}
          />
        </span>
      );
      // const sourceApproved = !isCatalog && !isMarketPlace && storeData.storeItemId && (
      //   <span
      //     className={`status-dot ${storeData.sourceApproved ? 'success' : 'failure'}`}
      //     title={formatMessage(`This Item has been Toggled-${storeData.sourceApproved ? 'On' : 'Off'} `)}
      //   />
      // );
      detailData.push({
        ...storeData,
        ...packrow,
        bulkTotalQty: sortedStoreData.packrows[0].isBulk ? sortedStoreData.availableQuantity : 0,
        action: readOnly ? (
          <div className="group-item-action">
            { !(isDistributor && !isWarehouse && !isCatalog) && (
                  image ? (<img
                    src={image || ''}
                    alt=""
                    style={{
                      objectFit: 'unset',
                      height: 40,
                      width: 40,
                      cursor: 'pointer',
                    }}
                    onClick={onImageClick}
                  />) : (<div className="box-48" />) 
                )
            }
            {toggler}
            {!isFarm && !isDistributor && (
              <QRCode
                size={40}
                value={`item - ${storeData.id}`}
              />
            )}
          </div>
        ) : (
          <div className="group-item-action">
            <EditItemButton
              modeTable
              contactId={id}
              info={storeData}
              isApproved={isFarm ? storeData.approved : storeData.sourceApproved}
              title={readOnlyForPermission ? formatMessage(getPermissionWarning) : formatMessage('Edit')}
              updateStateData={modifiedData => updateStateData(this, {
                ...modifiedData,
                noDispatch: true,
              })}
              reloadStore={reloadStore}
              isAllowedToUpdate={isAllowedToUpdate}
              isRetailPage={isRetailPage}
            />
            <ProductItemImage
              disabled={isAllowedToUpdate ? readOnlyForPermission : true}
              onUpload={onUploadImage}
              onRemove={onRemoveImage}
              image={image}
              info={storeData}
              reloadStore={reloadStore}
              requesting={imageRequesting}
              title={readOnlyForPermission ? formatMessage(getPermissionWarning) : formatMessage('Add Photo')}
            />
            
            {/* {sourceApproved} */}
            {
              storeData.productData.approved === false ? (
                <Badge type="pending">
                  {formatMessage('Pending')}
                </Badge>
              ) : (
                <div className="d-flex flex-column">
                  {toggler}
                </div>
              )
            }
            {!isFarm && !isDistributor && (
              <QRCode
                size={40}
                value={`item - ${storeData.id}`}
              />
            )}
            {/* {!isMarketPlace && !isFarm && (
              <span
                className={`status-dot ${isFarm ? (storeData.approved ? 'success' : 'failure')
                : (storeData.sourceApproved ? 'success' : 'failure')}`}
                title={formatMessage(`This Item has been Toggled-${(isFarm ? (storeData.approved
                  ? 'success' : 'failure') : (storeData.sourceApproved
                    ? 'success' : 'failure')) === 'success' ? 'On' : 'Off'}`)}
              />
            )} */}
            <span>
              {
                (!isFarm && storeData.isNew && !isMarketPlace) ?
                (
                  <div className="new-item" title={formatMessage('New Item')}>
                    <Badge type="new-item" id={storeData.id}>
                      {formatMessage('New')}
                    </Badge>
                  </div>
                ) : null
              }
            </span>
          </div>
        ),
        itemOn: readOnly ? (
          <div className="group-item-action">
            {toggler}
          </div>
        ) : (
          <div className="group-item-action">
            {
              storeData.productData.approved === false ? (
                <Badge type="pending">
                  {formatMessage('Pending')}
                </Badge>
              ) : (
                <div className="d-flex flex-column">
                  {toggler}
                </div>
              )
            }
          </div>
        ),
        image: readOnly ? (
          <div className="group-item-action">
            {image ? (<img
              src={image || ''}
              alt=""
              style={{
                objectFit: 'unset',
                height: 40,
                width: 40,
                cursor: 'pointer',
              }}
              onClick={onImageClick}
            />) : (<div className="box-48" />) }
          </div>
        ) : (
          <div className="group-item-action">
            <ProductItemImage
              disabled={isAllowedToUpdate ? readOnlyForPermission : true}
              onUpload={onUploadImage}
              onRemove={onRemoveImage}
              image={image}
              info={storeData}
              reloadStore={reloadStore}
              requesting={imageRequesting}
              title={readOnlyForPermission ? formatMessage(getPermissionWarning) : formatMessage('Add Photo')}
            />
          </div>
        ),
        edit: readOnly ? (
          <div className="group-item-action">
            {!isFarm && !isDistributor && (
              <QRCode
                size={40}
                value={`item - ${storeData.id}`}
              />
            )}
          </div>
        ) : (
          <div className="group-item-action">
            <EditItemButton
              modeTable
              contactId={id}
              info={storeData}
              isApproved={isFarm ? storeData.approved : storeData.sourceApproved}
              title={readOnlyForPermission ? formatMessage(getPermissionWarning) : formatMessage('Edit')}
              updateStateData={modifiedData => updateStateData(this, {
                ...modifiedData,
                noDispatch: true,
              })}
              reloadStore={reloadStore}
              isAllowedToUpdate={isAllowedToUpdate}
              isRetailPage={isRetailPage}
            />
            {!isFarm && !isDistributor && (
              <QRCode
                size={40}
                value={`item - ${storeData.id}`}
              />
            )}
            <span>
              {
                (!isFarm && storeData.isNew && !isMarketPlace) ?
                (
                  <div className="new-item" title={formatMessage('New Item')}>
                    <Badge type="new-item" id={storeData.id}>
                      {formatMessage('New')}
                    </Badge>
                  </div>
                ) : null
              }
            </span>
          </div>
        ),
        category: storeData.productData.category,
        id: storeData.id,
        index,
        isMinCount: true,
        name: storeData.productData.name,
        subname: storeData.productData.subname,
      });
    });

    return detailData;
  }

  toggle = (toggled) => {
    const { updateStateData } = this.props;
    updateStateData(this, { approved: toggled, noDispatch: true });
  }

  render() {
    const { fields, innerRef, searchText, updateStateData, classes } = this.props;
    const { storeData, currentTime } = this.state;
    const rowClassName = storeData.approved ? 'normal' : 'gray';
    const detailData = this.getDetailedData();
    return (
      <TableRow 
        className={rowClassName}
        classes={{
          root: classes.tableRowRoot,
        }}
        ref={innerRef} 
        key={currentTime}
      >
        {
          fields.map((field, index) => (
            <TableCell
              colSpan={field.colSpan || 1}
              key={index}
              style={{ verticalAlign: 'top', width: field.name === "sourcename" || field.name === "description"  ? '120px' : '' }}
            >
              {
                detailData.map((row, index) => {
                  const value = field.render ? field.render({ ...row, instance: this, setState: (...args) => updateStateData(this, ...args) }) : (row.isSeparator ? '' : row[field.name]);
                  const title = field.title ? (
                    typeof field.title === 'function' ? field.title(row) : field.title
                  ) : value;
                  const searchedValue = !field.searchDisabled && !field.render && searchText
                    ? <HighlightText text={value} highlight={searchText} /> : value;
                  const className = field.overflowHidden ? 'overflow-hidden' : typeof field.className === 'function' ? field.className(row) : field.className;
                  const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;

                  return (
                    <div
                      className={`${className || ''} pack-row pack-row-${field.name}`}
                      key={index}
                      title={title || ''}
                    >
                      {!isEmpty && searchedValue}
                    </div>
                  );
                })
              }
            </TableCell>
          ))
        }
      </TableRow>
    );
  }
}

export default compose(
  setDisplayName('StoreTableRow'),
  withStyles(styles),
)(StoreTableRow);
